import React, { useState, useEffect } from 'react';
import { SelectProps } from '@material-ui/core/Select';
import { PasslyDropdown } from '@app/components';
import { IActiveFilter, IFilterSelect, TranslationsTypes } from '@app/models';
import { saveActiveFilter } from '@app/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { useTypedTranslation } from '@app/hooks';
import { resetState } from '@app/store/actions';

interface IProps extends SelectProps {
    data: IFilterSelect[];
    label: TranslationsTypes;
    filtername: string;
    filterby?: string;
}

export function PasslyFilterSelect(props: IProps) {
    const [value, setValue] = useState('');
    const [valuesLabel, setValuesLabel] = useState('');

    const dispatch = useDispatch();
    const activeFilters: IActiveFilter[] = useSelector((state: any) => state.listPageBar.activeFilters);

    const { data, label, filterby, filtername } = props;

    const { translation } = useTypedTranslation();

    useEffect(() => {
        if (value !== '') {
            dispatch(saveActiveFilter(value, filtername, valuesLabel, filterby));
        }
    }, [value]);

    useEffect(() => {
        if (!activeFilters.some((filter: IActiveFilter) => filter.name === filtername)) {
            setValue('');
            setValuesLabel('');
        }
    }, [activeFilters]);

    const handleChange = (event: any) => {
        const value = event.target.value;
        dispatch(resetState());
        setValue(value);
        setValuesLabel(value);
    };

    const getTemplate = (item: any) => {
        return item?.label ? translation(item?.label) : '';
    };

    return (
        <PasslyDropdown
            className='passlySelect'
            value={value}
            options={data}
            itemTemplate={getTemplate}
            valueTemplate={getTemplate}
            onChange={handleChange}
            appendTo={document.body}
            optionLabel='label'
            label={label ? translation(label) : undefined}
            disabled={data.length === 0}
        />
    );
}
